import { BodyHeight } from './BodyHeight.js';
import { BodyWeight } from './BodyWeight.js';
/**
 * The patient-reportable scalar measurements, keyed by kind — the subset of {@link MEASUREMENTS} that can
 * be collected as an input (unlike the derived {@link BodyMassIndex}). {@link ScalarMeasurementKind} is
 * derived from these keys, so a scalar kind cannot exist without a definition here.
 */
export const SCALAR_MEASUREMENTS = {
    BODY_WEIGHT: BodyWeight,
    BODY_HEIGHT: BodyHeight,
};
//# sourceMappingURL=scalarMeasurements.js.map